module.exports = __webpack_public_path__ + "img/solution-market1.a31459ff.png";